/* eslint-disable no-nested-ternary */
import React from "react";
import { Box, CircularProgress, Typography, Tooltip } from "@mui/material";
import Dropdown from "src/components/shared/molecules/dropdown";
import useStyles from "./Styles";

interface GeneralCardProps {
  count: number;
  loader: boolean;
  title: string;
  cardImage: any;
  dropDownValues: any;
  changeSelect?: any;
  tourId?: string;
  hideDropdown?: boolean;
}

const GeneralCard: React.FC<GeneralCardProps> = ({
  loader,
  count,
  title,
  cardImage,
  dropDownValues,
  changeSelect,
  tourId,
  hideDropdown = false,
}) => {
  const { classes } = useStyles();
  return (
    <Box id={tourId} className={classes.root}>
      <Box className={classes.leftPart}>
        <Typography className={classes.value}>
          {loader ? (
            <CircularProgress size={30} />
          ) : count > 999 ? (
            <Tooltip title={count} placement="right" arrow>
              <span>999+</span>
            </Tooltip>
          ) : (
            count
          )}
        </Typography>
        <Typography className={classes.text}>{title}</Typography>
      </Box>
      <Box className={classes.rightPart}>
        {!hideDropdown && (
          <Dropdown
            usersSelectValue={dropDownValues}
            handleChangeSelect={changeSelect}
          />
        )}
        <Box className={classes.imgContainer}>
          <img src={cardImage} alt="SalesDone" className={classes.cardImage} />
        </Box>
      </Box>
    </Box>
  );
};

export default GeneralCard;
